<template>
  <div class="p-menu">
    <div class="l-container c-box">
      <SubHeaderMenu class="subMenu" />
      <MenuNavigation />

      <div class="menu-main-content">
        <div class="menu-box">
          <div class="menu-toolbar">
            <div class="toolbar-left">
              <a-space>
                <div class="field">
                  <a-date-picker
                    v-model="datetime"
                    type="date"
                    clearable
                    placeholder="日付未定"
                  >
                  </a-date-picker>
                </div>
                <div class="field">
                  <a-input>
                    <template #prefix>
                      <i class="icon icon-bor-people" />
                    </template>
                  </a-input>
                </div>
                <div class="field">
                  <a-input>
                    <template #suffix
                      ><i class="icon icon-bor-circle-plus"
                    /></template>
                  </a-input>
                </div>
              </a-space>
            </div>

            <div class="toolbar-right">
              <i class="icon icon-bor-circle-question pr-2" />
              <span>ご利用方法</span>
            </div>
          </div>

          <div class="menu-tags pt-4">
            <a-space>
              <Tag round closable>露天風呂</Tag>
              <Tag round closable>WiFiあり</Tag>
              <Tag round closable>マッサージ</Tag>
            </a-space>
          </div>
        </div>

        <div class="menu-tabs-wrap">
          <div class="menu-boxs">
            <a-tabs size="large">
              <a-tab-pane key="1" :tab="width < 1023 ? `プラン（${plansTotal}）` : `プランごとに見る（${plansTotal}）`">
                <div class="menu-box">
                  <div class="menu-pagination">
                    <p class="pagination-total">
                      <strong class="page-number">{{plansTotal}}</strong>件中 {{(pagination.page * 10) - 9}}～{{(pagination.page * 10)}}件表示</p>
                      <Pagination class="flex justify-center sm:hidden pt-2 pb-2" :page="pagination.page" :totalRecord="plansTotal" @onChange="paging" />
                    <div class="pagination-right">
                      <a-select v-model="value"
                                :options="options"
                                placeholder="おすすめ順"
                      />
                    </div>
                  </div>
                </div>

                <div class="menu-box" v-for="(i, idx) in plans.length" :key="`plans-${idx}`">
                  <LoadingContent v-if="isLoading" />

                  <div class="box-content pt-8">
                    <div class="flex items-start">
                      <div class="label label-primary mt-2 mr-4">NEW</div>
                      <h3>{{plans[idx][0].TITLE}}</h3>
                    </div>
                  </div>
                  <div class="main-recommended-footer pb-6">
                    <div class="recommended-left">
                      <img src="~@/assets/images/recomment-rakuten.png" alt="demo" />
                      <div class="services-offer">
                        <div class="item">
                          <i class="icon icon-bor-food" />
                          <span>朝食のみ</span>
                        </div>
                      </div>
                    </div>
                    <div class="recommended-right">
                      <div v-for="(item, index) in tagsText" :key="`tagsText-${index}`">
                        <Tag :text="`${item}`" class="ml-2" />
                      </div>
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="list-hotel">
                    <div v-for="(room, idxx) in rooms[idx]" :key="`rooms-${idxx}`">
                      <HotelItem v-if="room.room_id != null" :hidePriceProps="true" :data="room"/>
                    </div>
                  </div>
                  <div class="divider"></div>

                  <div v-if="roomsTotal[idx] > 0" class="flex justify-center py-4 view-more">
                    <button class="btn-viewmore">
                      <span>お部屋をすべて見る（{{roomsTotal[idx]}}）</span>
                      <i
                        class="
                          icon icon-bor-triangle-down
                          text-primary
                          pl-1
                          text-xs
                        "
                      />
                    </button>
                  </div>

                  <div v-if="roomsTotal[idx] > 0" class="flex justify-center py-4">
                    <button class="btn-viewmore">
                      <span>閉じる</span>
                      <i
                        class="
                          icon icon-bor-triangle-up
                          text-primary
                          pl-1
                          text-xs
                        "
                      />
                    </button>
                  </div>
                </div>

                <div class="menu-box">
                  <div class="menu-pagination border-b-0">
                    <p class="pagination-total">
                      <strong class="page-number">128</strong>件中 1～10件表示</p>
                    <Pagination :page="1" :pageCount="5" :pageSlot="5">
                      <template #prefix>
                        <button>
                          <i class="icon icon-bor-arrow-p-l" />
                        </button>
                      </template>
                      <template #suffix>
                        <button>
                          <i class="icon icon-bor-arrow-p-r" />
                        </button>
                      </template>
                    </Pagination>
                    <div class="pagination-right">
                      <a-select v-model="value"
                                :options="options"
                                placeholder="おすすめ順"
                               
                      />
                    </div>
                  </div>
                </div>

                <div class="menu-box">
                  <div class="flex gap-x-0.5">
                    <div class="menu-tags-footer whitespace-nowrap rounded-tl-sm rounded-bl-sm">
                      <i class="icon icon-bor-circle-question pr-2" />
                      ご利用方法
                    </div>
                    <div class="flex items-center menu-tags-footer w-full rounded-tr-sm rounded-br-sm">
                      <a href="#">申込み手順</a>
                      <a-divider type="vertical" />
                      <a href="#">受付開始時間になっても申込みができない場合</a>
                      <a-divider type="vertical" />
                      <a href="#">受付開始日の確認方法</a>
                      <a-divider type="vertical" />
                      <a href="#">提携プランを全て確認する方法</a>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" :tab="width < 1023 ? '部屋（256）' : '部屋ごとに見る（256）'">
                <div class="view-room-wrapper">
                  <div class="menu-pagination">
                    <p class="pagination-total"><strong class="page-number">128</strong>件中 1～10件表示</p>
                    <Pagination >
                      <template #prefix>
                        <button>
                          <i class="icon icon-bor-arrow-p-l" />
                        </button>
                      </template>
                      <template #suffix>
                        <button>
                          <i class="icon icon-bor-arrow-p-r" />
                        </button>
                      </template>
                    </Pagination>
                    <div class="pagination-right">
                      <a-select v-model="value"
                                :options="options"
                                placeholder="ページのトップへ"
                      />
                    </div>
                  </div>
                  <div class="sidebar">
                    <div class="room-box">
                      <HotelItem type="horizonal"/>
                    </div>
                    <div class="divider" />
                    <div
                      class="justify-center py-4 view-more mb-4 hidden lg:flex"
                    >
                      <button class="btn-viewmore">
                        <span>お部屋をすべて見る（4）</span>
                        <i
                          class="icon icon-bor-triangle-down text-primary pl-1 text-xs"
                        />
                      </button>
                    </div>
                    <div class="divider" />
                    <div class="room-box">
                      <HotelItem type="horizonal"/>
                    </div>
                  </div>
                  <div class="main-content">
                    <div class="room-box pb-0 lg:py-0">
                      <div class="divider hidden lg:block mt-0" />
                      <div v-for="(item, index) in nameRoom" :key="`nameRoom-${index}`">
                        <RoomItem :nameRoom="item.content" />
                        <div class="divider" />
                      </div>

                      <div class="flex justify-center py-0 view-more">
                        <button class="btn-viewmore">
                          <span>お部屋をすべて見る（4）</span>
                          <i
                            class="icon icon-bor-triangle-down text-primary pl-1 text-xs "
                          />
                        </button>
                      </div>
                    </div>
                    <div class="divider" />
                    <div class="room-box lg:py-0">
                      <div v-for="(item, index) in nameRoom2" :key="`nameRoom2-${index}`">
                        <RoomItem :nameRoom="item.content" />
                        <div class="divider" />
                      </div>

                      <div class="divider hidden lg:block" />
                      <div class="justify-center py-4 lg:pt-0 hidden lg:flex">
                        <button class="btn-viewmore">
                          <span>閉じる</span>
                          <i
                            class="icon icon-bor-triangle-up text-primary pl-1 text-xs"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="view-room-footer">
                    <div class="menu-box">
                      <div class="menu-pagination border-b-0">
                        <p class="pagination-total">
                          <strong class="page-number">128</strong>件中 1～10件表示
                        </p>
                        <Pagination  :page="1" :pageCount="5" :pageSlot="5">
                          <template #prefix>
                            <button>
                              <i class="icon icon-bor-arrow-p-l" />
                            </button>
                          </template>
                          <template #suffix>
                            <button>
                              <i class="icon icon-bor-arrow-p-r" />
                            </button>
                          </template>
                        </Pagination>
                        <div class="pagination-right">
                          <a-select
                            v-model="value"
                            :options="options"
                            placeholder="ページのトップへ"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="menu-box">
                      <div class="menu-tags-footer">
                        <div class="flex items-center">
                          <i class="icon icon-bor-circle-question pr-2" />
                          ご利用方法
                        </div>
                        <a-divider type="vertical" />
                        <div>
                          <a href="#">申込み手順</a>
                          <a-divider type="vertical" />
                          <a href="#">
                            受付開始時間になっても申込みができない場合
                          </a>
                          <a-divider type="vertical" />
                          <a href="#">受付開始日の確認方法</a>
                          <a-divider type="vertical" />
                          <a href="#">受付開始日の確認方法</a>
                          <a-divider type="vertical" />
                          <a href="#">提携プランを全て確認する方法</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useBreakpoints from '@/utils/useBreakpoints'
import { Tag, Pagination } from '@/components/primitive'
const { width } = useBreakpoints()

import {
  SubHeaderMenu,
  MenuNavigation,
  HotelItem,
  RoomItem
} from '@/components/compound'

export default {
  components: {
    SubHeaderMenu,
    MenuNavigation,
    HotelItem,
    RoomItem,
    Tag,
    Pagination
  },
  data() {
    return {
      isLoading: false,
      plansTotal: 0,
      plans: [],
      roomsTotal: [],
      rooms: [],
      pagination: {
        page: 1
      },
      width,
      color: '#000',
      bgColor: '#f4f5f6',
      datetime: null,
      value: null,
      options: [
        {
          label: 'Everybody\'s Got Something to Hide Except Me and My Monkey',
          value: 'song0',
          disabled: true
        },
        {
          label: 'Drive My Car',
          value: 'song1'
        }
      ],
      tagsText: [
        '現地決済予約',
        '事前決済予約',
        'カフェポイント',
        'すくすくえいど',
        '介護補助'
      ],
      nameRoom: [
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        },
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        }
      ],
      nameRoom2: [
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        },
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        },
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        },
        {
          content:
            '部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長い場合部屋名が長...'
        }
      ],

      breadcrumb_data: ['トップ', '宿泊施設名宿泊施設名宿泊施設名宿泊施設名宿泊施設名'],
      data: {
        
      }
    
    }
  },
  methods: {
    onSearch() {
      this.getList()
    },
    async getList() {
      this.isLoading = true

      const params = {
        menuNo: this.$route.params.menuNo,
        page: this.pagination.page
      }

      // console.log(params)
      await this.$repositories('search').searchPlan(params).then(response => {
        // console.log(response.data.plansTotal)
        // console.log(response.data.plans)
        // console.log(response.data.roomsTotal)
        // console.log(response.data.rooms)
        this.plansTotal = response.data.plansTotal
        this.plans = response.data.plans
        this.roomsTotal = response.data.roomsTotal
        this.rooms = response.data.rooms
      })

      this.isLoading = false
    },
    paging(e) {
      // console.log(e)
      this.pagination.page = e
      this.getList()
    }
  },
  async mounted() {
    this.getList()
  },
  watch: {
    $route() {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.pagination-right{
  width: 150px;
}
.a-select{
  width: 150px !important;
}
.ant-select-enabled{
  width: 150px;
}
</style>
